import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { FaAngleRight, FaHashnode } from "react-icons/fa6";
import {
  FaInstagram,
  FaGithub,
  FaLinkedinIn,
  FaBehance,
  FaFacebook,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import "../Css/Pages/Communication.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

const Communication = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_514f9zp",
        "template_jpombde",
        form.current,
        "Miiz_Y055DtyIMZEH",
      )
      .then(
        (result) => {
          alert("Mesajınız başarıyla gönderildi!");
          e.target.reset();
        },
        (error) => {
          alert("Mesaj gönderilemedi. Lütfen tekrar deneyin.");
          console.log(error.text);
        },
      );
  };
  return (
    <>
      <Header />
      <div>
        <div className="communication-page-header">
          <div className="communication-page-title">
            <h1>İletişim</h1>
          </div>
          <div className="communication-page-breadcrumb">
            <a href="/">Anasayfa</a>
            <FaAngleRight className="communication-page-breadcrumb-icon" />
            <strong>İletişim</strong>
          </div>
        </div>
        <div className="communication-page-contact-container">
          <div className="communication-page-contact-info">
            <strong>E-Mail</strong>
            <a href="mailto:volkankiycakofficial@gmail.com">
              İnfo@volkankiycakofficial@gmail.com
            </a>
            <div className="communication-page-social-links">
              <div>
                <a
                  href="https://www.linkedin.com/in/volkankiycak"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn profilime git"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href="https://github.com/volkankiycak"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub profilime git"
                >
                  <FaGithub />
                </a>
                <a
                  href="https://www.behance.net/volkankiycak"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn profilime git"
                >
                  <FaBehance />
                </a>
                <a
                  href="https://hashnode.com/@volkankiycak"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram hesabımı gör"
                >
                  <FaHashnode />
                </a>
              </div>
              <div>
                <a
                  href="https://www.instagram.com/kiycakofficial/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram hesabımı gör"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.instagram.com/kiycakofficial/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Kariyer.net özgeçmişimi gör"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://x.com/volkankiycak"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub profilime git"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://www.youtube.com/@volkankiycak"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Kariyer.net özgeçmişimi gör"
                >
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>
          <form
            className="communication-page-contact-form"
            ref={form}
            onSubmit={sendEmail}
          >
            <div className="communication-page-form-field">
              <strong>Adınız Soyadınız</strong>
              <input
                type="text"
                name="from_name"
                placeholder="Adınız Soyadınız"
                required
              />
            </div>
            <div className="communication-page-form-field">
              <strong>E-Mail</strong>
              <input type="email" name="email" placeholder="E-Mail" required />
            </div>
            <div className="communication-page-form-field">
              <strong>Telefon</strong>
              <input type="number" name="phone_number" placeholder="Telefon" />
            </div>
            <div className="communication-page-form-field">
              <strong>Mesajınız</strong>
              <textarea
                type="text"
                name="message"
                placeholder="Mesajınız"
                cols="23"
                rows="4"
                className="communication-page-textarea-field"
                required
              />
            </div>
            <button type="submit" className="communication-page-submit-button">
              <div>
                <strong className="communication-page-button-text">
                  Gönder
                </strong>
              </div>
              <div>
                <IoIosSend className="communication-page-send-icon" />
              </div>
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Communication;
